import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getDashboardOverview = () => apiClient.get(ENDPOINTS.STATISTICS.DASHBOARD);

export const getUserStatistics = (params) => apiClient.get(ENDPOINTS.STATISTICS.USERS, { params });

export const getRegistrationStatistics = (params) => apiClient.get(ENDPOINTS.STATISTICS.REGISTRATIONS, { params });

export const getRevenueStatistics = (params) => apiClient.get(ENDPOINTS.STATISTICS.REVENUE, { params });

export const getExamStatistics = (examId = null) => {
  const url = examId ? ENDPOINTS.STATISTICS.EXAM(examId) : ENDPOINTS.STATISTICS.EXAMS;
  return apiClient.get(url);
};

export const getSpeakingStatistics = (params) => apiClient.get(ENDPOINTS.STATISTICS.SPEAKING, { params });

export const getScoreStatistics = (params) => apiClient.get(ENDPOINTS.STATISTICS.SCORES, { params });

export const getReferralStatistics = () => apiClient.get(ENDPOINTS.STATISTICS.REFERRALS);

export const getExamRegistrations = (examId, params) => apiClient.get(ENDPOINTS.STATISTICS.EXAM_REGISTRATIONS(examId), { params });
